import { isSessionStorageAvailable } from "utils/utils";

export const THEME_STORAGE_KEY = "lassie-theme";

type Theme = {
  cta: string;
};

const themes: Record<string, Theme> = {
  leocare: {
    cta: "#2E374D",
  },
};

export type Partner = keyof typeof themes;

export const isThemePartner = (partner: string | string[] | undefined) => {
  if (!partner) {
    return false;
  }

  return true;
};

export const useSignupTheme = () => {
  const partner = isSessionStorageAvailable()
    ? window.sessionStorage.getItem(THEME_STORAGE_KEY)
    : null;

  const theme = partner ? themes[partner] : null;

  return theme || null;
};
